<template>
  <div class="mapa-voluntarios-container">
    <div class="row mb-4">
      <div class="col-md-12">
        <h4 class="text-transparencia fw-600 mb-3">
          <i class="fa fa-map mr-2"></i>
          Distribución de Voluntarios por Departamento
        </h4>
        <p class="text-muted">
          Mapa interactivo que muestra la distribución de voluntarios en todo el territorio peruano
        </p>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-transparencia text-white">
            <h5 class="mb-0">
              <i class="fa fa-chart-bar mr-2"></i>
              Mapa de Calor
            </h5>
          </div>
          <div class="card-body p-0">
            <div v-if="cargando" class="text-center p-5">
              <div class="spinner-border text-transparencia" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
              <p class="mt-2 text-muted">Cargando mapa...</p>
            </div>
            <div v-else-if="error" class="text-center p-5">
              <i class="fa fa-exclamation-triangle fa-3x text-warning mb-3"></i>
              <p class="text-muted">Error al cargar el mapa</p>
              <button @click="cargarMapa" class="btn btn-outline-primary btn-sm">
                <i class="fa fa-refresh mr-1"></i> Reintentar
              </button>
            </div>
            <div v-else-if="datawrapperMap" 
                 v-html="datawrapperMap" 
                 class="datawrapper-container">
            </div>
            <div v-else class="text-center p-5">
              <i class="fa fa-map fa-3x text-muted mb-3"></i>
              <p class="text-muted">No hay mapa disponible</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'view-mapa-voluntarios',
  
  data() {
    return {
      datawrapperMap: null,
      cargando: false,
      error: false
    }
  },
  
  methods: {
    async cargarMapa() {
      this.cargando = true
      this.error = false
      
      try {
        const response = await this.$http.get(this.apiRoute('Common', 'GetVoluntariosMap'))
        
        if (!response.body.error && response.body.data && response.body.data.datawrapperMap) {
          this.datawrapperMap = response.body.data.datawrapperMap
          this.cargarScriptDatawrapper()
        } else {
          this.error = true
        }
      } catch (error) {
        console.error('Error al cargar el mapa:', error)
        this.error = true
      } finally {
        this.cargando = false
      }
    },
    
    cargarScriptDatawrapper() {
      // Cargar script de Datawrapper para el iframe
      if (!document.querySelector('#datawrapper-script')) {
        const script = document.createElement('script')
        script.id = 'datawrapper-script'
        script.type = 'text/javascript'
        script.textContent = `
          !function(){"use strict";window.addEventListener("message",function(a){if(void 0!==a.data["datawrapper-height"]){var e=document.querySelectorAll("iframe");for(var t in a.data["datawrapper-height"])for(var r,i=0;r=e[i];i++)if(r.contentWindow===a.source){var d=a.data["datawrapper-height"][t]+"px";r.style.height=d}}})}();
        `
        document.head.appendChild(script)
      }
    }
  },
  
  mounted() {
    this.cargarMapa()
  }
}
</script>

<style scoped>
.card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.bg-transparencia {
  background-color: #2484da !important;
}

.text-transparencia {
  color: #2484da !important;
}

/* Estilos para el contenedor de Datawrapper */
.datawrapper-container {
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}

.datawrapper-container iframe {
  border-radius: 0 0 8px 8px;
  transition: all 0.3s ease;
  width: 100% !important;
  height: 718px !important;
}

.datawrapper-container iframe:hover {
  transform: scale(1.01);
}

/* Spinner personalizado */
.spinner-border.text-transparencia {
  color: #2484da !important;
}

/* Centrado y formato del mapa */
.mapa-voluntarios-container {
  max-width: 100%;
  margin: 0 auto;
}

.mapa-voluntarios-container .card {
  margin: 0 auto;
  max-width: 100%;
}

.mapa-voluntarios-container .card-body {
  text-align: center;
  padding: 0;
}

.datawrapper-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.datawrapper-container iframe {
  max-width: 100%;
  height: auto;
  border-radius: 0 0 8px 8px;
}

/* Responsive */
@media (max-width: 768px) {
  .mapa-voluntarios-container .row {
    margin-left: -15px;
    margin-right: -15px;
  }
  
  .mapa-voluntarios-container .col-md-12 {
    padding-left: 15px;
    padding-right: 15px;
  }
  
  .datawrapper-container iframe {
    height: 500px !important;
  }
}

@media (max-width: 576px) {
  .datawrapper-container iframe {
    height: 400px !important;
  }
}
</style>